import {
    formatError,
    login,
    phoneLogin,
    forgotPassword,
    updatePassword,
    runLogoutTimer,
    saveTokenInLocalStorage,
    phoneUser,
    signUp,
} from '../../services/AuthService';
import _ from "lodash";

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';

export function signupAction(email, password, history) {
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                history,
            );
            dispatch(confirmedSignupAction(response.data));
            history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function logout(history) {
    localStorage.removeItem('userDetails');
    history.push('/login');
    return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, history) {
    return (dispatch) => {
        login(email, password)
            .then((response) => {
                console.log(response);
                saveTokenInLocalStorage(response.data);
                // runLogoutTimer(
                //     dispatch,
                //     response.data.expiresIn * 1000,
                //     history,
                // );
                dispatch(loginConfirmedAction(response.data));
                
				history.push('/dashboard');
            })
            .catch((error) => {
				console.log();
                var errorMessage = '';
                if (!_.isEmpty(error.response)) {
                    errorMessage = formatError(error.response.data);
                }
                else{
                    errorMessage = formatError({message: 'NETWORK_ERROR'});
                }
                dispatch(loginFailedAction(errorMessage));
            });
    };
}


export function phoneUserAction(phonecode, history) {
    return (dispatch) => {
         console.log(phonecode);
          phoneUser(phonecode)
            .then((response) => {
                console.log(response);
                 
                if (response.data.status == 'success') {
                    localStorage.setItem('phone', phonecode);
                    history.push('/phone-password');
                }
            })
            .catch((error) => {
                console.log();
                var errorMessage = '';
                if (!_.isEmpty(error.response)) {
                    errorMessage = formatError(error.response.data);
                }
                else {
                    errorMessage = formatError({ message: 'NETWORK_ERROR' });
                }
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function phoneLoginAction(password, history) {
    return (dispatch) => {

        let phone = localStorage.getItem('phone');
           phoneLogin(phone,password)
               .then((response) => {
                   saveTokenInLocalStorage(response.data);
                   // runLogoutTimer(
                   //     dispatch,
                   //     response.data.expiresIn * 1000,
                   //     history,
                   // );
                  dispatch(loginConfirmedAction(response.data));
                console.log(response);
                history.push('/dashboard');
               
            })
            .catch((error) => {
                console.log();
                var errorMessage = '';
                if (!_.isEmpty(error.response)) {
                    errorMessage = formatError(error.response.data);
                }
                else {
                    errorMessage = formatError({ message: 'NETWORK_ERROR' });
                }
                dispatch(loginFailedAction(errorMessage));
            });
    };
}


export function forgotPasswordAction(email, history) {
    return (dispatch) => {
        forgotPassword(email)
            .then((response) => {
                console.log(response);
                     
                if (response.data.status == 'success') {
                    localStorage.setItem('userEmail', email);
                    history.push('/new-password');
                }

                
            })
            .catch((error) => {
                console.log();
                var errorMessage = '';
                if (!_.isEmpty(error.response)) {
                    errorMessage = formatError(error.response.data);
                }
                else {
                    errorMessage = formatError({ message: 'NETWORK_ERROR' });
                }
                dispatch(loginFailedAction(errorMessage));
            });
    };
}


export function updatePasswordAction(password, history) {
    return (dispatch) => {

        let email = localStorage.getItem('userEmail');

            updatePassword(password,email)

            .then((response) => {
                console.log(response);
                history.push('/login');
        
            })
            .catch((error) => {
                console.log();
                var errorMessage = '';
                if (!_.isEmpty(error.response)) {
                    errorMessage = formatError(error.response.data);
                }
                else {
                    errorMessage = formatError({ message: 'NETWORK_ERROR' });
                }
                dispatch(loginFailedAction(errorMessage));
            });
    };
}






export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
